const constants = {
  UPDATE_USER_INFO: "UPDATE_USER_INFO",
  UPDATE_USER_INFO_DSS: "UPDATE_USER_INFO_DSS",
  UPDATE_ALERT: "UPDATE_ALERT",
  UPDATE_SCREEN: "UPDATE_SCREEN",
  TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",

  // User Details
  UPDATE_USER_DETAILS: "UPDATE_USER_DETAILS",

  // SOURCE DATA
  UPDATE_SOURCE_INPUT: "UPDATE_SOURCE_INPUT",

  // ADMIN DATA
  UPDATE_ADMIN_INPUT: "UPDATE_ADMIN_INPUT",
};

export default constants;
